import React, { createRef } from 'react';
import { NavigateParams } from '../services/Navigator';
import { MainStyle } from '../assets/styles/MainStyle';
import { checkSerieAvaliable, getBanner } from '../services/ApiServices';
import { View, TouchableOpacity, Image, ScrollView, Text, Linking, Modal, Alert } from 'react-native';
import { setData, getData } from '../services/StorageService';
import skeleton from '../assets/images/skeleton.gif';
import { Base64 } from 'js-base64';
import TopBar from '../components/TopBar';

export default class MainScreen extends React.Component {
    constructor(props) {
        super(props);
        const styles = MainStyle();

        this.touchableRef = createRef(),
        this.state = {
            redirect: { redirect: { status: false, value: '' } },
            styles: styles,
            cfBanner: skeleton,
            sfBanner: skeleton,
            fdBanner: skeleton,
            isLoading: false,
            showInstagramWarning: false
        }
    }

    componentDidMount() {
        // if (!this.isInstagramBrowser()) {
            this.selectSystemSF();
            this.capturaParametrosUrlShareLink();
        // } else {
        //     this.setState({ showInstagramWarning: true });
        // }
    }

    // Método para verificar se está no Instagram
    isInstagramBrowser() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        return userAgent.includes("Instagram");
    }

    // Método para abrir no navegador nativo
    openInNativeBrowser = () => {
        const url = window.location.href;
        
        // Tenta abrir usando deep linking
        Linking.openURL(url).catch(() => {
            // Fallback para web padrão
            Linking.openURL( "googlechrome://navigate?url=" + encodeURIComponent(url));
        });
    };

    // Método para clicar programaticamente
    triggerClick = () => {
        if (this.touchableRef.current) {
            this.touchableRef.current.props.onPress();
        }
    };

    openURL = async (url) => {
        const supported = await Linking.canOpenURL(url);
        if (supported) {
            await Linking.openURL(url);
        } else {
            Alert.alert(`Don't know how to open this URL: ${url}`);
        }
    }

    capturaParametrosUrlShareLink() {
        getData("sf_system_auth").then(res => {
            var url = window.location.href;

            var res = url.includes("?") ? url.split('?') : [];

            if (res.length > 0) {

                if (res[1].includes("seller=")) {
                    this.setState({ redirect: { status: true, value: 'ShareLinkSingUpScreen' } });
                }
                else {

                    this.capturaParametrosUrl();
                }
            }
            else {

                setTimeout(() => {
                    this.setState({ redirect: { status: true, value: 'LoginScreen' } });
                }, 100)
            }
        })
    }

    capturaParametrosUrl() {
        var url = window.location.href;
        let normalUrl = window.location.href.includes("&fbclid=")? window.location.href.split("&fbclid=")[0] : url
        var res = normalUrl.includes("?") ? normalUrl.split('?') : [];

        if (res.length > 0) {
            var result = Base64.decode(res[1].replace("qrcode=", ""));

            checkSerieAvaliable(JSON.parse(result).currentSystem == "sf" ? "https://api.cartelas.app/api/v1/app" : "https://api.cartelas.app/api/v1/app", JSON.parse(result).serieId).then(res => {

                if (res == true) {
                    setData("current_cartela_qrcode_data", result);
                    this.setState({ redirect: { status: true, value: 'ClientValidateOrder' } });
                }
            })

        }

    }

    getSFBanner() {
        getBanner("https://api.cartelas.app/api/v1/app").then(res => this.setState({ sfBanner: res ? { uri: res.banner } : skeleton }))
    }

    selectSystemSF() {
        setData("current_system_color", '#3e4095');
        setData("current_system", "sf");
        setData("current_url", "https://api.cartelas.app/api/v1/app");
        this.setState({ redirect: { status: true, value: 'LoginScreen' } });
    }

    render() {
        return (
            <View>
                <TopBar navigation={this.props.navigation} isLoading={this.state.isLoading}>
                    <View style={this.state.styles.viewPort}>
                        {/* Modal de aviso do Instagram */}
                        <Modal
                            visible={this.state.showInstagramWarning}
                            transparent={true}
                            animationType="fade"
                            onRequestClose={() => this.setState({ showInstagramWarning: false })}
                        >
                            <View style={{
                                flex: 1,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                justifyContent: 'center',
                                alignItems: 'center',
                                padding: 20
                            }}>
                                <View style={{
                                    backgroundColor: 'white',
                                    padding: 20,
                                    borderRadius: 10,
                                    alignItems: 'center',
                                    width: '80%'
                                }}>
                                    <Text style={{
                                        fontSize: 18,
                                        fontWeight: 'bold',
                                        marginBottom: 15,
                                        textAlign: 'center'
                                    }}>
                                        Aviso do Instagram
                                    </Text>
                                    
                                    <Text style={{
                                        marginBottom: 20,
                                        textAlign: 'center'
                                    }}>
                                        Para uma melhor experiência, recomendamos abrir o aplicativo no navegador do seu aparelho.
                                    </Text>
                                    
                                    <TouchableOpacity 
                                        style={{
                                            backgroundColor: '#3e4095',
                                            padding: 10,
                                            borderRadius: 5,
                                            marginBottom: 10,
                                            width: '100%',
                                            alignItems: 'center'
                                        }}
                                        onPress={this.openInNativeBrowser}
                                    >
                                        <Text style={{ color: 'white' }}>Abrir no Navegador</Text>
                                    </TouchableOpacity>
                                    
                                    <TouchableOpacity 
                                        style={{
                                            padding: 10,
                                            width: '100%',
                                            alignItems: 'center'
                                        }}
                                        onPress={() => this.setState({ showInstagramWarning: false })}
                                    >
                                        <Text style={{ color: '#3e4095' }}>Continuar no Instagram</Text>
                                    </TouchableOpacity>
                                </View>
                            </View>
                        </Modal>

                        {this.state.redirect.status ? <NavigateParams navigation={this.props.navigation} screen={this.state.redirect.value} params={{ MSG: 'OK' }}></NavigateParams> : <Text></Text>}
                        <View style={this.state.styles.container}>

                            <View style={{ height: 40, ...this.state.styles.row, ...this.state.styles.bgLight, ...this.state.styles.justifyCenter, ...this.state.styles.alignCenter }}>
                                <Text style={{ ...this.state.styles.bold, ...this.state.styles.fs14, ...this.state.styles.cDark }}>Clique na imagem e escolha suas cartelas</Text>
                            </View>
                            <ScrollView>
                                <View style={{ ...this.state.styles.container, padding: 6 }}>
                                    <TouchableOpacity ref={this.touchableRef} style={this.state.styles.mt8} onPress={this.selectSystemSF.bind(this)}>
                                    </TouchableOpacity>
                                </View>
                            </ScrollView>
                        </View>
                    </View>
                </TopBar>
            </View>
        );
    }
}